import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SignUp({ onAuthenticate }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const [username, setUsername] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    const user = { name, email, username, password };

      const response = await fetch('https://bot-battle-server.vercel.app/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        throw new Error('Failed to create account');
      }

      const data = await response.json();
      console.log('Account created:', data);

      alert('Account created successfully');
      onAuthenticate(); 
      navigate('/'); 
    }

  return (
    <div className="flex justify-center mt-44">
      <form onSubmit={handleSubmit} className="border-slate-500 border-2 w-96 rounded-lg flex gap-12 flex-col bg-slate-200 p-4">
        <div className="text-center text-2xl">
          <h2>SIGN-UP PAGE</h2>
        </div>
        <div className="flex gap-7 ml-7">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="rounded-md text-center"
          />
        </div>
        <div className="flex gap-7 ml-7">
          <label htmlFor="email">Email:</label>
          <input
            type="text"
            id="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="rounded-md text-center"
          />
          </div>
          <div className="flex gap-7 ml-7">
          <label htmlFor="phone">User-name:</label>
          <input
            type="text"
            id="username"
            placeholder="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="rounded-md text-center"
          />
        </div>
        <div className="flex gap-7 ml-7">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="rounded-md text-center"
          />
        </div>
        <div className="flex gap-7 ml-7">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="rounded-md text-center"
          />
        </div>
        <div className="flex gap-7 justify-center mb-7 text-xl">
          <button type="submit" className="text-blue-500">Create Account</button>
        </div>
      </form>
    </div>
  );
}

export default SignUp
